import { useIsExpertOrGreater } from "../data/Results/useIsExpertOrGreater";
import { useTranslation } from "react-i18next";
import { Checkbox, Stack, Tooltip } from "@mui/material";
import { useContext } from "react";
import { AuthContext } from "../contexts/AuthContext";

interface Props {
  customerId: number;
  substationId?: number;
  substationName: string;
  captureId: number;
  report: boolean;
  showGenerateReport: boolean;
  isLoading: boolean;
  setShowGenerateReport: (showGenerateReport: boolean) => void;
  onChange(captureId: number): (event: React.ChangeEvent<HTMLInputElement>) => void;
}

export function ReportCheckbox(props: Props) {
  const { t } = useTranslation();
  const {
    customerId,
    substationId,
    substationName,
    captureId,
    report,
    showGenerateReport,
    isLoading,
    setShowGenerateReport,
    onChange,
  } = props;

  const isExpertOrGreater = useIsExpertOrGreater(customerId, substationId, substationName);
  const isEaEmployee = useContext(AuthContext).amIEaEmployee();

  const isEaEmployeeExpertOrGreater = isEaEmployee && isExpertOrGreater.data?.valueOf();
  const checkboxEnabled = isEaEmployeeExpertOrGreater;
  const displayFlexibleSurveysTooltip = isEaEmployeeExpertOrGreater;

  const tooltipTitle = displayFlexibleSurveysTooltip
    ? t("results.reportCheckboxDisabledFlexibleSurveys")
    : t("results.reportCheckboxDisabledInvalidPermissions");

  if (!showGenerateReport && isExpertOrGreater.data?.valueOf()) {
    setShowGenerateReport(true);
  }

  return (
    <Stack alignItems="center">
      {isLoading ? (
        <Tooltip title={t("results.reportCheckboxLoading")}>
          <div>
            <Checkbox disabled={true} />
          </div>
        </Tooltip>
      ) : checkboxEnabled ? (
        <Checkbox
          key={`checkbox-${captureId}`}
          id={captureId.toString()}
          checked={report}
          onChange={onChange(captureId)}
        />
      ) : (
        <Tooltip title={tooltipTitle}>
          <div>
            <Checkbox disabled={true} />
          </div>
        </Tooltip>
      )}
    </Stack>
  );
}
